import { Container } from '@almbrand/container';
import { Grid } from '@almbrand/grid';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import './ContainerLayout.scss';
import { GridCellComponent } from './GridCellComponent';

export const ContainerLayout: React.FC<{ component: ContentApiModel }> = ({ component }) => {
	const { style, content } = component ?? {};
	const { innerBackgroundColor, gridStyle, marginBottom, marginTop } = style ?? {};
	const { useReadline, readlineId, contentId, isInvertedOnMobile } = content ?? {};

	const getDefaultMargin = (value: string) => (['', 'default'].includes(value) ? 'spacing-r' : value);

	const isNotificationVisible = (block: any) => {
		const inner = block?.content;
		if (inner?.contentType !== 'NotificationBlock') return true;
		return !sessionStorage.getItem(`close-notification-banner-${inner.contentId}`);
	};

	const computeVisible = () => {
		if (content?.contentType === 'DefaultContainerBlock') {
			const items = content.mainArea?.items ?? [];
			return items.some(isNotificationVisible);
		}
		return isNotificationVisible(component);
	};

	const [showContainer, setShowContainer] = useState<boolean>(computeVisible);

	useEffect(() => {
		const handler = () => setShowContainer(computeVisible());
		window.addEventListener('notification-banner-closed', handler);
		return () => {
			window.removeEventListener('notification-banner-closed', handler);
		};
	}, [component]);

	if (!showContainer) return null;

	return (
		<Container
			desktopWidth='1600'
			tabletWidth='1280'
			mobileWidth='744'
			backgroundColor={innerBackgroundColor?.cssClass}
			id={useReadline && readlineId ? readlineId : contentId}
			className={classNames(
				`pb-${getDefaultMargin(marginBottom)}`,
				`pt-${getDefaultMargin(marginTop)}`,
				'container-layout'
			)}
		>
			<Grid
				container={gridStyle === 'fullscreen'}
				className={classNames(
					content?.contentType === 'DefaultContainerBlock' && isInvertedOnMobile && 'reverse-order'
				)}
			>
				{content?.contentType === 'DefaultContainerBlock' ? (
					content?.mainArea?.items?.map((subItem, subIndex) => (
						<GridCellComponent
							component={subItem}
							key={subIndex}
							applySpacings
						/>
					))
				) : (
					<GridCellComponent
						component={component}
						applySpacings={false}
					/>
				)}
			</Grid>
		</Container>
	);
};
